(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[35453],{

/***/ 35453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhyUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/insurancesupersaver/svg/comparisonIcon.tsx


function ComparisonIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#dff0fe",
                d: "M32 30.5c-2.623 0-5-1.614-5.997-4h11.994c-.997 2.386-3.374 4-5.997 4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M37.192 27c-1.057 1.816-3.034 3-5.192 3s-4.135-1.184-5.192-3h10.384m1.514-1H25.294A7 7 0 0032 31a7 7 0 006.706-5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M32 9.145l5.653 16.859C36.813 28.372 34.531 30 32 30s-4.813-1.628-5.653-3.995L32 9.145M32 6l-6.706 20A7 7 0 0032 31a7 7 0 006.706-5L32 6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#dff0fe",
                d: "M8 30.5c-2.623 0-5-1.614-5.997-4h11.994c-.997 2.386-3.374 4-5.997 4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M13.192 27c-1.057 1.816-3.034 3-5.192 3s-4.135-1.184-5.192-3h10.384m1.514-1H1.294A7 7 0 008 31a7 7 0 006.706-5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M8 9.145l5.653 16.859C12.813 28.372 10.531 30 8 30s-4.813-1.628-5.653-3.995L8 9.145M8 6L1.294 26A7 7 0 008 31a7 7 0 006.706-5L8 6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "#4788c7",
                strokeMiterlimit: "10",
                d: "M31.963 8.333C28.372 4.743 22.867 4.763 20 7.63"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M32 6a2 2 0 100 4 2 2 0 100-4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "#4788c7",
                strokeMiterlimit: "10",
                d: "M8.037 8.333c3.591-3.59 9.096-3.57 11.963-.703"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M22 4a2 2 0 11-4 0c0-1.105 1.438-2.469 2-3 .5.484 2 1.895 2 3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#b6dcfe",
                d: "M18.5 7.5h3v27h-3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M21 8v26h-2V8h2m1-1h-4v28h4V7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#b6dcfe",
                d: "M12.5 38.5V37c0-.827.673-1.5 1.5-1.5h2.5V35c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v.5H26c.827 0 1.5.673 1.5 1.5v1.5h-15z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M20 32c1.654 0 3 1.346 3 3v1h3c.551 0 1 .449 1 1v1H13v-1c0-.551.449-1 1-1h3v-1c0-1.654 1.346-3 3-3m0-1c-2.2 0-4 1.8-4 4h-2c-1.1 0-2 .9-2 2v2h16v-2c0-1.1-.9-2-2-2h-2c0-2.2-1.8-4-4-4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#b6dcfe",
                d: "M20 5.5a2.5 2.5 0 100 5 2.5 2.5 0 100-5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M20 6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2m0-1a3 3 0 100 6 3 3 0 000-6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#4788c7",
                    d: "M8 6a2 2 0 100 4 2 2 0 100-4z"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/insurancesupersaver/svg/GuidanceIcon.tsx


function GuidanceIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#98ccfd",
                d: "M20 38.5C9.799 38.5 1.5 30.201 1.5 20S9.799 1.5 20 1.5 38.5 9.799 38.5 20 30.201 38.5 20 38.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M20 2c9.925 0 18 8.075 18 18s-8.075 18-18 18S2 29.925 2 20 10.075 2 20 2m0-1C9.507 1 1 9.507 1 20s8.507 19 19 19 19-8.507 19-19S30.493 1 20 1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#b6dcfe",
                d: "M20 36.5c-9.098 0-16.5-7.402-16.5-16.5S10.902 3.5 20 3.5 36.5 10.902 36.5 20 29.098 36.5 20 36.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M20 4c8.822 0 16 7.178 16 16s-7.178 16-16 16S4 28.822 4 20 11.178 4 20 4m0-1C10.611 3 3 10.611 3 20s7.611 17 17 17 17-7.611 17-17S29.389 3 20 3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36 22l-5-2 5-2.071zM4 22l5-2-5-2.071zM17.929 4L20 9l2-5zm0 32L20 31l2 5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#dff0fe",
                d: "M17.369 17.369L28.77 11.23l-6.139 11.401L11.23 28.77z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M27.539 12.461l-5.277 9.801-9.801 5.277 5.277-9.801 9.801-5.277M30 10l-13 7-7 13 13-7 7-13z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M17.122 17.829l5.049 5.049L11.23 28.77z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#4788c7",
                        d: "M17.243 18.657l4.099 4.099-8.882 4.782 4.783-8.881M17 17l-7 13 13-7-6-6z"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/insurancesupersaver/svg/privacyIcon.tsx


function PrivacyIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "#4788c7",
                strokeMiterlimit: "10",
                strokeWidth: "2",
                d: "M30 17.714V12c0-5.523-4.477-10-10-10S10 6.477 10 12v5.714"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#b6dcfe",
                d: "M2.5 37.5V22c0-3.584 2.916-6.5 6.5-6.5h22c3.584 0 6.5 2.916 6.5 6.5v15.5h-35z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M31 16c3.308 0 6 2.692 6 6v15H3V22c0-3.308 2.692-6 6-6h22m0-1H9a7 7 0 00-7 7v16h36V22a7 7 0 00-7-7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#dff0fe",
                d: "M20 19.5a7.5 7.5 0 100 15 7.5 7.5 0 100-15z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M20 20c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-1a8 8 0 100 16 8 8 0 000-16z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4788c7",
                d: "M20 24a3 3 0 100 6 3 3 0 100-6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M22.5 23a1.5 1.5 0 100 3 1.5 1.5 0 100-3z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/variables/insurancesupersaverVariables.module.scss
var insurancesupersaverVariables_module = __webpack_require__(25192);
var insurancesupersaverVariables_module_default = /*#__PURE__*/__webpack_require__.n(insurancesupersaverVariables_module);
// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/insurancesupersaver/whyUs/index.tsx







const whyUsList = [
    {
        title: "Expert Guidance on the Right Policy",
        description: "We go beyond simply offering affordable rates. When you receive your quote, you gain the ability to compare prices, read customer reviews, evaluate benefits, and more, ensuring you make an informed decision.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidanceIcon, {})
    },
    {
        title: "Effortless Side-by-Side Comparisons",
        description: "Eliminate the need for multiple browser tabs. Our platform simplifies your insurance shopping experience. Through our efficient and comprehensive search, you can access multiple quotes from the industry's top providers, all conveniently in one place.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonIcon, {})
    },
    {
        title: "Stringent Privacy Controls",
        description: "Your privacy matters to us just as much as it does to you. Whether you request quotes online, over the phone, or directly from carriers, rest assured that we will never share your information with any third parties.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyIcon, {})
    }, 
];
function WhyUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: whyUsList,
        mainTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "What Does ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "InsuranceSuperSaver.com"
                }),
                " Offer You?"
            ]
        }),
        classes: {
            mainSectionClasses: "max-w-7xl mx-auto block px-4vw lg:px-4",
            mainTitleClasses: "text-center text-xl lg:text-2xl mb-10",
            innerSectionClasses: "lg:flex",
            oneBoxClasses: "text-center mb-12 lg:border-l lg:first:border-l-0",
            iconClasses: " children:w-12 children:h-12 children:mx-auto",
            titleClasses: "font-bold text-lg lg:text-xl mt-6",
            descriptionClasses: "font-light text-sm lg:text-base text-justify w-4/5 mx-auto mt-2"
        },
        colors: {
            mainTitleColor: (insurancesupersaverVariables_module_default()).assault,
            titleColor: (insurancesupersaverVariables_module_default()).assault,
            descriptionColor: "#4788c7"
        }
    });
}


/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);